import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18894236")

_pushScopeId("data-v-18894236")
const _hoisted_1 = {
  class: "page",
  style: {"padding":"16px 12px 0px 12px"}
}
const _hoisted_2 = { style: {"padding":"16px 10px 0px 10px"} }
const _hoisted_3 = { style: {"color":"white","font-size":"2.5vh","font-style":"blod","padding-bottom":"1vh"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "health-horizontal-line" }, null, -1)
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","padding-top":"5vh"} }
const _hoisted_6 = {
  class: "d-flex flex-column justify-center items-center circle-slot",
  style: {"height":"100%"}
}
const _hoisted_7 = { class: "health-container" }
const _hoisted_8 = { class: "health-item health-itemFont" }
const _hoisted_9 = { class: "health-num" }
const _hoisted_10 = { class: "health-otherFont" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", null, "BMP", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "health-item health-itemFont" }, "|", -1)
const _hoisted_13 = { class: "health-item health-itemFont" }
const _hoisted_14 = { class: "health-num" }
const _hoisted_15 = { class: "health-otherFont" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "%", -1)
const _hoisted_17 = { style: {"font-size":"2.5vh"} }
const _hoisted_18 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_19 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#328cb5"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_bk.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_21 = { class: "health-iconFontBody" }
const _hoisted_22 = { class: "health-iconFontColor" }
const _hoisted_23 = { style: {"display":"inline-block"} }
const _hoisted_24 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#c06e2c"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_rmssd.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_26 = { class: "health-iconFontBody" }
const _hoisted_27 = { class: "health-iconFontColor" }
const _hoisted_28 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#b1a62b"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_dbp.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_30 = { class: "health-iconFontBody" }
const _hoisted_31 = { class: "health-iconFontColor" }
const _hoisted_32 = { style: {"display":"inline-block"} }
const _hoisted_33 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_34 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#1e60a3"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_rr.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_35 = { class: "health-iconFontBody" }
const _hoisted_36 = { class: "health-iconFontColor" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" RR ")
const _hoisted_38 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_39 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#993030"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_sdnn.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_40 = { class: "health-iconFontBody" }
const _hoisted_41 = { class: "health-iconFontColor" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" SDNN ")
const _hoisted_43 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_44 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#2fa988"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_rmssd.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_45 = { class: "health-iconFontBody" }
const _hoisted_46 = { class: "health-iconFontColor" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" RMSSD ")
const _hoisted_48 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_49 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#284987"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_nn50.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_50 = { class: "health-iconFontBody" }
const _hoisted_51 = { class: "health-iconFontColor" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" NN50 ")
const _hoisted_53 = {
  class: "health-item health-iconItemFont iconItem",
  style: {"flex":"0 0 25%"}
}
const _hoisted_54 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#c1832a"},
  class: "health-iconItemImg"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "/images/icon/icon_pnn50.png",
    width: "25",
    height: "25",
    alt: "Report Icon"
  })
], -1)
const _hoisted_55 = { class: "health-iconFontBody" }
const _hoisted_56 = { class: "health-iconFontColor" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" PNN50 ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_circle = _resolveComponent("van-circle")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_KeepAlive, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_my_card, null, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_my_card_body, null, {
                default: _withId(() => [
                  _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("health.healthEquipment")), 1),
                  _hoisted_4,
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_van_circle, {
                      "current-rate": $setup.convertToPercentage($setup.count),
                      "layer-color": "rgba(255,255,255,.05)",
                      color: $setup.percentFormat($setup.count).style,
                      size: "18vh",
                      "stroke-width": "100",
                      onClick: $setup.startHealthTest
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_6, [
                          _createVNode("div", {
                            style: {
                        color: $setup.percentFormat($setup.count).style,
                        fontWeight: 'bold',
                        fontSize: '25px',
                      },
                            class: "score-content"
                          }, _toDisplayString($setup.count ? Math.floor($setup.convertToPercentage($setup.count)) : 0) + "% ", 5),
                          _createVNode("p", {
                            style: {
                        color: $setup.percentFormat($setup.count).style,
                      }
                          }, _toDisplayString($setup.percentFormat($setup.count).desc) + " " + _toDisplayString($setup.disconnectFlag ? "连接断开" : "") + " " + _toDisplayString($setup.abnormalFlag ? "采集数据异常" : ""), 5)
                        ])
                      ]),
                      _: 1
                    }, 8, ["current-rate", "color", "onClick"])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.heartRate
                        ? $setup.healthRealtimeData.heartRate
                        : "--"), 1),
                      _createVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("health.heartRateStatus")), 1 /* TEXT */)
                      ])
                    ]),
                    _hoisted_12,
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.spo2
                        ? $setup.healthRealtimeData.spo2
                        : "--"), 1),
                      _createVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("health.bloodOxygenStatus")), 1 /* TEXT */)
                      ])
                    ])
                  ]),
                  _createVNode("div", null, [
                    _createVNode("blockquote", null, [
                      _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("health.PulseWave")), 1)
                    ]),
                    _createVNode("div", {
                      ref: $setup.setRef,
                      style: {"height":"28vh","width":"100%"}
                    }, null, 512),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", _hoisted_22, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.bk
                            ? $setup.healthRealtimeData.bk
                            : "0") + "% ", 1),
                          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("health.microcirculation")), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("div", _hoisted_26, [
                          _createVNode("div", _hoisted_27, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rsv
                            ? $setup.healthRealtimeData.rsv[3]
                            : "0"), 1),
                          _createVNode("span", null, _toDisplayString(_ctx.$t("health.systolicPressure")), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode("div", _hoisted_30, [
                          _createVNode("div", _hoisted_31, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rsv
                            ? $setup.healthRealtimeData.rsv[4]
                            : "0"), 1),
                          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("health.diastolicPressure")), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode("div", _hoisted_35, [
                          _createVNode("div", _hoisted_36, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rra
                            ? $setup.healthRealtimeData.rra.reduce(
                                (acc, curr) => acc + curr,
                                0
                              )
                            : "0"), 1),
                          _hoisted_37
                        ])
                      ]),
                      _createVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode("div", _hoisted_40, [
                          _createVNode("div", _hoisted_41, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.sdnn
                            ? $setup.healthRealtimeData.sdnn
                            : "0"), 1),
                          _hoisted_42
                        ])
                      ]),
                      _createVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode("div", _hoisted_45, [
                          _createVNode("div", _hoisted_46, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.rmssd
                            ? $setup.healthRealtimeData.rmssd
                            : "0"), 1),
                          _hoisted_47
                        ])
                      ]),
                      _createVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createVNode("div", _hoisted_50, [
                          _createVNode("div", _hoisted_51, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.nn50
                            ? $setup.healthRealtimeData.nn50
                            : "0"), 1),
                          _hoisted_52
                        ])
                      ]),
                      _createVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode("div", _hoisted_55, [
                          _createVNode("div", _hoisted_56, _toDisplayString($setup.healthRealtimeData && $setup.healthRealtimeData.pnn50
                            ? $setup.healthRealtimeData.pnn50
                            : "0"), 1),
                          _hoisted_57
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 1024))
})